module.exports = __webpack_public_path__ + "img/report-icon.a93f9b89.svg";